var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('account-data')],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('change-password')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }